export class RequiredFieldError extends Error {
    constructor() {
        super('필수 정보 입니다.')
        this.name = 'RequiredFieldError'
    }
}
